<div class="datepicker-background">
  <input #contactsPicker
         type="text"
         name="daterangeInput"
         ccInput
         class="date-picker form-control"
         daterangepicker
         [options]="options"
         [id]="inputId"
         (selected)="selectedDate($event)"
         [autofocus]="autoFocused"
         (clickOutside)="exitPicker($event)"/>
</div>

